import { handleResult } from '@/helpers/utils/functionality-utils';
import { userModule } from '@/module/userModule';
import ApiService, { type RequestOptions } from '@/services/apiService';
import type {
  AddTaskRequestInterface,
  MyTask,
  TaskAssignedByMe,
} from '@/types/user/task-types';

export class TasksService {
  private userApiService: ApiService;
  constructor() {
    this.userApiService = new ApiService(userModule);
  }

  async addTask(data: AddTaskRequestInterface) {
    const response = await this.userApiService.post<null>(
      '/api/v1/task/add',
      data,
    );
    return handleResult(response);
  }

  async getMyTasks(data: RequestOptions['params']) {
    const status = data?.status;
    const filteredObject: RequestOptions['params'] = {};
    if (data)
      Object.keys(data).forEach((key) => {
        if (key.toLowerCase() !== 'status') {
          filteredObject[key] = data[key];
        }
      });

    const response = await this.userApiService.get<MyTask[]>(
      `/api/v1/task/my/${status}/tasks`,
      filteredObject,
    );
    return handleResult(response);
  }

  async getTasksAssignedByMe(data: RequestOptions['params']) {
    const status = data?.status;
    const filteredObject: RequestOptions['params'] = {};
    if (data)
      Object.keys(data).forEach((key) => {
        if (key.toLowerCase() !== 'status') {
          filteredObject[key] = data[key];
        }
      });
    const response = await this.userApiService.get<TaskAssignedByMe[]>(
      `/api/v1/task/assigned/${status}/tasks`,
      filteredObject,
    );
    return handleResult(response);
  }

  async markTask(data: { task_id: number; status: string }) {
    const response = await this.userApiService.patch<null>(
      `/api/v1/task/${data.task_id}/mark/${data.status}`,
    );
    return handleResult(response);
  }

  async deleteTask(taskId: number) {
    const response = await this.userApiService.delete<null>(
      `/api/v1/task/${taskId}/remove`,
    );
    return handleResult(response);
  }
}
